<template>
	<div>
		<notifications />
		<section class="heading">
			<h1 class="title">Proposals</h1>
			<router-link to="proposals/create" class="btn btn-primary btn-lg">Add new Proposal</router-link>
		</section>
        <div class="container">
			<div class="row">
				<div class="float-right">
					<div class="col-xs-6 col-sm-3">
						<input-wrapper id="customer" label="Customer">
							<customer-dropdown :onChange="handleCustomerFilter"></customer-dropdown>
						</input-wrapper>
					</div>
					<div class="col-xs-6 col-sm-3">
						<input-wrapper id="search" label="Search">
							<search :initialValue="searchItem.search" :onClear="handleSearch"></search>
                            <preloader v-if="isLoading"></preloader>
						</input-wrapper>
					</div>
				</div>
			</div>
		</div>
		<div class="table-responsive">
			<table class="table">
				<thead>
					<tr>
						<th>Proposal Information</th>
						<th width="15%">Grand Total</th>
						<th>Expired Date</th>
						<th>Created Date</th>
						<th>Last Sent Email</th>
						<th></th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="item in proposals.data" :key="item.id">
						<td>
							<b><router-link :to="relativeUrl(`/proposals/${item.id}/view`)">{{ item.number }} <br />{{ item.title }}</router-link></b> <br/>
						</td>
						<td>{{ formatPrice(item.grandtotal) }}</td>
						<td>{{ displayDate(item.expired_at) }}</td>
						<td>{{ displayDate(item.date) }}</td>
						<td>
							<time-ago :datetime="`${item.last_sent_email_at}`" long v-if="isValidDate(item.last_sent_email_at)"></time-ago>
						</td> 
						<td>
							<action-button id="dropdownMenu1">
								<ul class="dropdown-menu" aria-labelledby="dropdownMenu1">
									<li><router-link :to="relativeUrl(`/proposals/${item.id}/edit`)">Edit</router-link></li>
									<li><router-link :to="relativeUrl(`/proposals/create?duplicate_id=${item.id}`)">Duplicate</router-link></li>
									<li><router-link :to="relativeUrl(`/proposals/${item.id}/view`)">View</router-link></li>
									<li><a href="#" @click="remove(item.id)">Delete</a></li>
								</ul>
							</action-button>
						</td>
					</tr>
					<tr colspan="5" v-if="proposals.data.length <= 0">
						No data
					</tr>
				</tbody>
			</table>
		</div>
		<amy-pagination :pagination="proposals"></amy-pagination>
	</div>
</template>

<script>
import { getPage, relativeUrl, formatPrice, displayDate, isValidDate } from "../../helpers";
import AmyPagination from "../AmyPagination.vue";
import ActionButton from "../ActionButton.vue";
import TimeAgo from "vue2-timeago";
import CustomerDropdown from "../CustomerDropdown.vue";
import Search from "../Search.vue";
import InputWrapper from "../InputWrapper.vue";
import Preloader from "../Preloader.vue";

export default {
	components: {
		AmyPagination, ActionButton, TimeAgo, CustomerDropdown, Search, InputWrapper, Preloader
    },
    props:{
    },
	data() {
		return {
			proposals: {
				total: 0,
				per_page: 10,
				from: 1,
				to: 0,
				current_page: 1,
				data: [],
            },
			isLoading: false,
            searchItem: {
                search : "",
                filter : "",
            },
            selected:"",
		}
	},
	beforeMount() {
		this.getProposals();
	},
	beforeRouteUpdate(to, from, next) {
		this.getProposals(to);
		next();
	},
	methods: {
        clearInput(e){
            this.searchItem.search = null;
            this.getProposals();
        },
        clearSelect(e){
            this.searchItem.filter = null;
            this.getProposals();
        },

        async handleSearch(search) {
            this.searchItem.search = (search ? search : "");
            this.getProposals();
        },
        
        async handleCustomerFilter(customer) {
            this.searchItem.filter = (customer ? customer.id : "");
            this.getProposals();
        },
        
		async remove(id) {
			this.isLoading = true;

			try {
				const response = await axios.delete(`/proposals/${id}`);
				this.getProposals();
				this.$notify({
					type: 'success',
					title: 'Proposal Deleted!',
					text: 'You\'ve deleted the proposal!'
				})
			} catch {
				this.$notify({
					type: 'error',
					title: 'Oops!',
					text: 'Sorry, an error occured!'
				})
			}

			this.isLoading = false;
		},
		async getProposals(route = this.$route) {
            this.isLoading = true;
            const params = { 
                page: getPage(route), 
                search: this.searchItem.search,
                filter: this.searchItem.filter,
                limit: 10
            };

			try {
				const response = await axios.get(`/proposals`, { params });
				this.proposals = { ...response.data };
			} catch {
				this.$notify({
					type: 'error',
					title: 'Oops!',
					text: 'Sorry, an error occured!'
				})
			}

			this.isLoading = false;
        },
		relativeUrl, formatPrice, displayDate, isValidDate
	}
}
</script>
